import React from 'react'

export default function () {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlSpace="preserve"
      viewBox="0 0 26.458 26.458"
    >
      <path
        fill="#00a396"
        fillRule="evenodd"
        d="M9.033 3.82a.722.722 0 0 1 .386.946l-.2.48 1.802.276a9.386 9.386 0 0 1 5.694 3.161l.076.089a7.942 7.942 0 0 0 4.71 2.658l3.033.51a.722.722 0 0 1 .512 1.06 46.002 46.002 0 0 0-3.849 9.177.722.722 0 0 1-.812.507l-3.037-.51a9.386 9.386 0 0 1-5.566-3.141l-.076-.088a7.942 7.942 0 0 0-4.818-2.676l-2.16-.332-2.017 4.806a.722.722 0 0 1-1.332-.559L8.088 4.207a.722.722 0 0 1 .945-.386Z"
        clipRule="evenodd"
      />
      <path
        fill="#fff"
        stroke="#00a396"
        strokeLinejoin="round"
        strokeWidth="3.969"
        d="M8.686 4.236v2.54h5l-4.391 5.795h2.937c2.354 0 3.942 1.482 3.942 3.757 0 2.513-1.905 3.757-3.863 3.757H9.427l-1.905 2.54h4.789c4.26 0 6.959-3.096 6.959-6.297 0-3.44-2.038-5.503-4.922-6.112l4.551-5.98Z"
        aria-label="3"
        paintOrder="stroke fill markers"
      />
    </svg>
  )
}
